import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Calendar Multiselect"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-calendar-multiselect',
    templateUrl: './icon-calendar-multiselect.component.html',
    styleUrls: ['./icon-calendar-multiselect.component.scss'],
    standalone: false
})
export class IconCalendarMultiselectComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
